import { ReferralView } from "@/admin/marketing/ReferralView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/referral")({
    component: ReferralView,
});
